import React from 'react';
import styled, { css } from 'styled-components';
import { arrayOf, shape, string, node } from 'prop-types';
import { C_EBON, C_WHITE } from '@bbc/psammead-styles/colours';
import { GEL_BREVIER } from '@bbc/gel-foundations/typography';
import { GEL_SPACING, GEL_SPACING_DBL, GEL_MARGIN_BELOW_400PX, GEL_MARGIN_ABOVE_400PX } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import Link from './Link';
import List from './List';
export var layoutWrapperWithoutGrid = /*#__PURE__*/css(["@media (max-width:", "){padding:0 ", ";}@media (min-width:", "){padding:0 ", ";}"], GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_MARGIN_BELOW_400PX, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_MARGIN_ABOVE_400PX);
var SitewideLinksWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SitewideLinksWrapper",
  componentId: "sc-1gggobt-0"
})(["", ";background-color:", ";", ";", ""], layoutWrapperWithoutGrid, C_EBON, GEL_BREVIER, function (_ref) {
  var service = _ref.service;
  return getSansRegular(service);
});
var ConstrainedWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ConstrainedWrapper",
  componentId: "sc-1gggobt-1"
})(["max-width:", ";margin:0 auto;", ""], GEL_GROUP_5_SCREEN_WIDTH_MIN, function (_ref2) {
  var trustProjectLink = _ref2.trustProjectLink;
  return trustProjectLink && "padding-top: ".concat(GEL_SPACING, ")");
});
var StyledParagraph = /*#__PURE__*/styled.p.withConfig({
  displayName: "StyledParagraph",
  componentId: "sc-1gggobt-2"
})(["color:", ";margin:0;padding:", " 0;"], C_WHITE, GEL_SPACING_DBL);

var SitewideLinks = function SitewideLinks(_ref3) {
  var links = _ref3.links,
      trustProjectLink = _ref3.trustProjectLink,
      copyrightText = _ref3.copyrightText,
      externalLink = _ref3.externalLink,
      service = _ref3.service;
  return /*#__PURE__*/React.createElement(SitewideLinksWrapper, {
    service: service
  }, /*#__PURE__*/React.createElement(ConstrainedWrapper, {
    trustProjectLink: trustProjectLink
  }, /*#__PURE__*/React.createElement(List, {
    links: links,
    trustProjectLink: trustProjectLink
  }), /*#__PURE__*/React.createElement(StyledParagraph, null, copyrightText, ' ', /*#__PURE__*/React.createElement(Link, {
    text: externalLink.text,
    href: externalLink.href,
    inline: true
  }))));
};

var linkPropTypes = shape({
  href: string.isRequired,
  text: string.isRequired
});
SitewideLinks.propTypes = {
  links: arrayOf(linkPropTypes.isRequired).isRequired,
  copyrightText: node.isRequired,
  trustProjectLink: linkPropTypes,
  externalLink: linkPropTypes.isRequired,
  service: string.isRequired
};
SitewideLinks.defaultProps = {
  trustProjectLink: null
};
export default SitewideLinks;